import { gql } from "@apollo/client";

export const EVALUATE_BEHAVIOR = gql`
  mutation EvaluateBehavior(
    $name: String!
    $rate: String!
    $description: String
    $householdId: String!
    $actionDate: Date!
  ) {
    evaluateBehavior(
      name: $name
      rate: $rate
      description: $description
      householdId: $householdId
      actionDate: $actionDate
    ) {
      message
    }
  }
`;
